customElements.get('product-form') ||
  customElements.define(
    'product-form',
    class extends HTMLElement {
      constructor() {
        super(),
        this.form = this.querySelector('form')
        this.cartUI = document.querySelector('cart-drawer') || document.querySelector('cart-items')
        this.gwpAttribute = this.dataset.gwpGift
        this.umgGwp = window.UmgGwp

        if (this.gwpAttribute !== undefined) {
          disableFormIfGwp()
        }

        function disableFormIfGwp() {
          const gwpProductForm = this
          if (gwpProductForm !== undefined) {
            gwpProductForm.remove()
          }
        }

        this.quantitySpinner = document.querySelector('quantity-input[data-variant-id="' + this.variantId + '"][data-section="' + this.sectionId + '"]'),
        this.submitButton = this.querySelector('button[type=submit]')
          this.querySelector('form')
            ? ((this.form = this.querySelector('form')),
              (this.form.querySelector('[name=id]').disabled = !1),
              this.form.addEventListener(
                'submit',
                this.onSubmitHandler.bind(this)
              ))
            : ((this.querySelector('[name=id]').disabled = !1),
              this.querySelector('button[type=submit]').addEventListener(
                'click',
                this.onSubmitHandler.bind(this)
              )),
          (this.cart =
            document.querySelector('cart-notification') ||
            document.querySelector('cart-drawer')),
          (this.submitButton = this.querySelector('[type="submit"]')),
          document.querySelector('cart-drawer') &&
            this.submitButton.setAttribute('aria-haspopup', 'dialog'),
          (this.hideErrors = 'true' === this.dataset.hideErrors);
      }
      onSubmitHandler(e) {
        let gwp_sections;
        if (!this.form) {
          this.form = document.querySelector('form');
        }
        const formData = new FormData(this.form);

        let quantity = 1;
        if (this.querySelector('input[name="quantity"]')) {
          quantity = this.querySelector('input[name="quantity"]').value;
        }
        formData.append('quantity', quantity);

        if (this.quantitySpinner != null && this.cartUI != null) {
          formData.append('sections', this.cartUI.getSectionsToRender().map((section) => section.id).concat(this.quantitySpinner.getSectionsToRender().map((section) => section.id)))
          gwp_sections = this.cartUI.getSectionsToRender().map((section) => section.id).concat(this.quantitySpinner.getSectionsToRender().map((section) => section.id))
          console.log(this.quantitySpinner)
        } else if (this.quantitySelector != null && this.cartUI != null) {
          formData.append('sections', this.cartUI.getSectionsToRender().map((section) => section.id).concat(this.quantitySelector.getSectionsToRender().map((section) => section.id)))
          gwp_sections = this.cartUI.getSectionsToRender().map((section) => section.id).concat(this.quantitySelector.getSectionsToRender().map((section) => section.id))
        } else {
          formData.append('sections', this.cartUI ? this.cartUI.getSectionsToRender().map((section) => section.id) : [])
          gwp_sections = this.cartUI ? this.cartUI.getSectionsToRender().map((section) => section.id) : []
        }
        formData.append('sections_url', window.location.pathname)
        const gwp_sections_url = window.location.pathname

        function isJson(item) {
          let value = typeof item !== "string" ? JSON.stringify(item) : item;    
          try {
            value = JSON.parse(value);
          } catch (e) {
            return false;
          }
          return typeof value === "object" && value !== null;
        }

        if (
          (e.preventDefault(),
          'true' !== this.submitButton.getAttribute('aria-disabled'))
        ) {
          this.handleErrorMessage(),
            this.submitButton.setAttribute('aria-disabled', !0),
            this.submitButton.classList.add('loading'),
            this.querySelector('.loading-overlay__spinner') && this.querySelector('.loading-overlay__spinner').classList.remove(
              'hidden'
            );
          let config = fetchConfig('javascript');
          (config.headers['X-Requested-With'] = 'XMLHttpRequest'),
            delete config.headers['Content-Type'];
          formData || formData.append('id', this.querySelector('[name=id]').value),
            this.cart &&
              (formData.append(
                'sections',
                this.cart.getSectionsToRender().map((section) => section.id)
              ),
              formData.append('sections_url', window.location.pathname),
              this.cart.setActiveElement(document.activeElement)),
            (config.body = formData),
            fetch('' + routes.cart_add_url, config)
              .then((t) => t.json())
              .then((t) => {
                var e;
                let errorMsg = '';
                if (isJson(t.description)) {
                  const parsedJson = JSON.parse(t.description);
                  if (parsedJson[0].error != '') {
                    errorMsg = parsedJson[0].error;
                  } else if (parsedJson[0].variants[0].error) {
                    errorMsg = parsedJson[0].variants[0].error;
                  }
                } else {
                  errorMsg = t.description;
                }
                if (t.status)
                  return (
                    publish(PUB_SUB_EVENTS.cartError, {
                      source: 'product-form',
                      productVariantId: formData.get('id'),
                      errors: t.description,
                      message: t.message,
                    }),
                    this.handleErrorMessage(errorMsg),
                    (e = this.submitButton.querySelector('.sold-out-message'))
                      ? (this.submitButton.setAttribute('aria-disabled', !0),
                        this.submitButton
                          .querySelector('span')
                          .classList.add('hidden'),
                        e.classList.remove('hidden'),
                        void (this.error = !0))
                      : void 0
                  );
                this.cart
                  ? (this.error ||
                      publish(PUB_SUB_EVENTS.cartUpdate, {
                        source: 'product-form',
                        productVariantId: formData.get('id'),
                      }),
                    (this.error = !1),
                    (e = this.closest('quick-add-modal'))
                      ? (document.body.addEventListener(
                          'modalClosed',
                          () => {
                            setTimeout(() => {
                              this.cart.renderContents(t);
                            });
                          },
                          { once: !0 }
                        ),
                        e.hide(!0))
                      : this.cart.renderContents(t))
                  : (window.location = window.routes.cart_url);
              })
              .catch((t) => {
                console.error(t);
              })
              .finally(() => {
                this.submitButton.classList.remove('loading'),
                  this.cart &&
                    this.cart.classList.contains('is-empty') &&
                    this.cart.classList.remove('is-empty'),
                  this.error ||
                    this.submitButton.removeAttribute('aria-disabled'),
                  this.querySelector('.loading-overlay__spinner').classList.add(
                    'hidden'
                  );
                fetchCart();
                if (this.umgGwp !== undefined) {
                  // Don't call umg gift with purchase if no gift with purchase data exists
                  UmgGwp(this.cartUI, gwp_sections, gwp_sections_url)
                }
              });
        }
      }
      handleErrorMessage(t = !1) {
        this.hideErrors ||
          ((this.errorMessageWrapper =
            this.errorMessageWrapper ||
            this.querySelector('.product-form__error-message-wrapper')),
          this.errorMessageWrapper &&
            ((this.errorMessage =
              this.errorMessage ||
              this.errorMessageWrapper.querySelector(
                '.product-form__error-message'
              )),
            this.errorMessageWrapper.toggleAttribute('hidden', !t),
            t) &&
            (this.errorMessage.textContent = t));
      }
    }
  );